
import { mathFormat } from '@/pages/intelligence/utils/commonUtils';
import { RecordItemType } from '@/pages/intelligence/components/SearchRecent/type';
import { getCountryFlag } from '@/pages/home/_config/countries';

export const toFixed0 = (value, point = 2) => {
  let _newVal: string | number = parseFloat(value);
  if (value == '' || isNaN(_newVal)) {
    return '-';
  }
  _newVal = _newVal.toFixed(point);
  return _newVal + '%';
};

//直接加%  小数小于1 大于0 ，保留2位小数  留存右列
export const toFixedAddPer = (value) => {
  let _newVal: string | number = parseFloat(value);
  if (isNaN(_newVal)) {
    return value;
  }
  //fix 0.99%变成1.00%
  if (Math.abs(_newVal.toFixed(2)) > 0 && Math.abs(_newVal.toFixed(2)) < 1) {
    _newVal = Math.abs(_newVal).toFixed(2);
  } else {
    _newVal = Math.abs(_newVal).toFixed(2);
  }
  return _newVal + '%';
};

export const handlePriceFormat = (value) => {
  if (value === null || value === '' || value === undefined) {
    return '-';
  }
  if (parseInt(value) === 0) {
    return 'Free';
  }
  return mathFormat(value, false, 0);
};

export const transTableDataForSearch = (res: any) => {
  const resultList = res?.data?.rank_au_list;
  if (!Array.isArray(resultList) || !resultList?.length) {
    return [];
  }
  const tranksList: RecordItemType[] = resultList.map((item) => {
    return {
      id: item?.app_id,
      imgSrc: item?.cover,
      lineOneStr: item?.name,
      lineTwoImg: getCountryFlag(item?.markets),
      lineTwoImgName: item?.markets,
      lineTwoStr: item?.publisher,
    };
  });
  return tranksList;
};